export default "__VITE_ASSET__BSkq3EED__"